import { useEffect } from 'react';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { COLLECTIONS, splitPath } from '@elka/firebase';
import { db } from '@/lib/firebase/config';
import { useAuth } from './useAuth';

/**
 * Merge-upserts the signed-in office user into the shared office directory (crm users),
 * so every elka-manager user is assignable in CRM and Tasks (e.g. Tasks' project manager).
 * ponytail: third copy of this upsert (crm useCRMUsers, tasks useRegisterOfficeUser) —
 * move it to @elka/hooks if a fourth app needs it.
 */
export function useRegisterOfficeUser() {
  const { user, tenantId } = useAuth();

  useEffect(() => {
    // The path needs the session tenant, so wait for the claims.
    if (!user || !tenantId) return;
    setDoc(
      doc(db, ...splitPath(COLLECTIONS.crm.users), user.uid),
      {
        id: user.uid,
        displayName: user.displayName || user.email || 'Unknown',
        email: user.email || '',
        photoURL: user.photoURL || null,
        lastSignIn: serverTimestamp(),
      },
      { merge: true }
    ).catch((err) => console.error('Failed to sync user to the office directory:', err));
  }, [user, tenantId]);
}
